import { observer } from 'mobx-react-lite'
import { FormRow } from '@/components/Form'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { type TeamDetailsViewModel } from '@/features/iam/teams/TeamDetailsViewModel'
import { useFeatures } from '@/contexts/root-store-context'
import { TeamDetails } from '@/features/iam/teams/components/TeamDetails'

export interface TeamDetailsContainerProps {
  vm: TeamDetailsViewModel
}

export const TeamDetailsContainer = observer(function TeamDetailsContainer({
  vm,
}: TeamDetailsContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))

  return (
    <TeamDetails
      onSubmit={vm.saveInfo}
      canEditDetails={vm.canEditDetails}
      isSavePending={vm.saveInfo.pending}
      hasChanges={vm.hasChanges}
      corporateMode={shellInfo.corporateMode}
      detailsFields={
        <>
          <FormRow>
            <TextInputContainer
              label="Team Name"
              field="name"
              model={vm}
              isDisabled={vm.saveInfo.pending || !vm.canEditDetails}
              error={vm.validation.getError('name')}
            />
          </FormRow>
          <FormRow>
            <TextInputContainer
              label="Team Slug"
              readOnly
              isDisabled
              field="slug"
              model={vm}
            />
          </FormRow>
          <FormRow>
            <TextInputContainer
              label="Team Owner"
              model={vm}
              field={'' as never}
              readOnly
              isDisabled
              placeholder={vm.team.owner.member.displayName}
            />
          </FormRow>
          <FormRow>
            <TextInputContainer
              label="Team Purpose"
              field="teamPurpose"
              model={vm}
              isDisabled={vm.saveInfo.pending || !vm.canEditDetails}
            />
          </FormRow>
        </>
      }
      addressFields={
        <>
          <FormRow>
            <TextInputContainer
              label="Street Address"
              field="streetAddress"
              model={vm}
              isDisabled={vm.saveInfo.pending || !vm.canEditDetails}
            />
          </FormRow>
          <FormRow>
            <TextInputContainer
              label="City"
              field="city"
              model={vm}
              isDisabled={vm.saveInfo.pending || !vm.canEditDetails}
            />
          </FormRow>
          <FormRow>
            <TextInputContainer
              label="State"
              field="state"
              model={vm}
              isDisabled={vm.saveInfo.pending || !vm.canEditDetails}
            />
          </FormRow>
          <FormRow>
            <TextInputContainer
              label="Zip Code"
              field="zipCode"
              model={vm}
              isDisabled={vm.saveInfo.pending || !vm.canEditDetails}
            />
          </FormRow>
          <FormRow>
            <TextInputContainer
              label="Country"
              field="country"
              model={vm}
              isDisabled={vm.saveInfo.pending || !vm.canEditDetails}
            />
          </FormRow>
        </>
      }
    />
  )
})
